export const SET_IN_PERSON_SERVICE = 'SET_IN_PERSON_SERVICE'
export const SET_CURRENT_IN_PERSON_SERVICE_USER = 'SET_CURRENT_IN_PERSON_SERVICE_USER'
export const SET_PARAMS_IN_PERSON_SERVICE = 'SET_PARAMS_IN_PERSON_SERVICE'